module.exports = require('preact-compat').createClass;



//////////////////
// WEBPACK FOOTER
// ./~/preact-compat/lib/create-react-class.js
// module id = 278
// module chunks = 35783957827783